<a href="tel:{{ phone.value | phone }}">{{ phone.value | phone }}</a>
@if (phone.type) {
	<span class="text-muted phone-type">[{{ phone.type }}]</span>
}
@if (phone.sms) {
	<span class="fa-stack sms-stack">
		<i aria-hidden="true" class="fa-sms fa-stack-1x far"></i>
	</span>
}
